<template>
	<el-config-provider
		:locale="locale"
		:size="config.size"
		:zIndex="config.zIndex"
		:button="config.button"
	>
		<keep-alive><router-view></router-view></keep-alive>
	</el-config-provider>
</template>

<script>
import colorTool from "@/utils/color";
//import config from "@/config"
export default {
	name: "App",
	data() {
		return {
			config: {
				size: "default",
				zIndex: 2000,
				button: {
					autoInsertSpace: false,
				},
			},
			isConnect:false,
		};
	},
	mounted() {
	},
	methods: {
		
	},
	computed: {
		locale() {
			return this.$i18n.messages[this.$i18n.locale].el;
		},
	},
	created() {
		//设置主题颜色
		const app_color =
			this.$CONFIG.COLOR || this.$TOOL.data.get("APP_COLOR");
		if (app_color) {
			document.documentElement.style.setProperty(
				"--el-color-primary",
				app_color
			);
			for (let i = 1; i <= 9; i++) {
				document.documentElement.style.setProperty(
					`--el-color-primary-light-${i}`,
					colorTool.lighten(app_color, i / 10)
				);
			}
			for (let i = 1; i <= 9; i++) {
				document.documentElement.style.setProperty(
					`--el-color-primary-dark-${i}`,
					colorTool.darken(app_color, i / 10)
				);
			}
		}
	},
};
</script>

<style lang="scss">
@import "@/style/style.scss"; 
</style>
